import { iconButtonClasses } from '@mui/material/IconButton';

export default {
	styleOverrides: {
		actions: {
			display: 'flex',
			gap: 8,
			marginRight: 6,
			[`& .${iconButtonClasses.root}`]: {
				minWidth: 0,
				width: 36,
				height: 36,
			},
		},
	},
}
